import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { deleteNotification } from "../../../redux/actions/admin/notificationActions";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";

export default function EmailDelete({ open, handleClose, uuid }) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const destroy = () => {
    dispatch(deleteNotification(uuid));
    handleClose();
  };

  return (
    <Dialog open={open} onClose={() => handleClose("delete")} fullWidth={true}>
      <DialogTitle
        className="border-b text-center"
        style={{ backgroundColor: "#CE4C4C" }}
      >
        <span className="font-bold font-poppins text-white">
          {t("notification.delete")}
        </span>
      </DialogTitle>
      <DialogContent>
        <DialogContent>
          <DialogContentText className="text-center">
            <span className="mt-2">{t("notification.message_delete")}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose("delete")}>
            {t("board.close_action")}
          </Button>
          <Button onClick={destroy}>{t("board.send_action")}</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
